import sum from 'lodash/sum';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { devServer, devServer_somee } from '../globalSettings';
import { SERVER_API } from '../../config-global';

// ----------------------------------------------------------------------

const initialState = {
    isLoading: false,
    error: null,
    User_RegisterUserSuccess: null,

};

const slice = createSlice({
    name: 'registerStructure',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

       
        User_RegisterUserSuccess(state, action) {
            state.isLoading = false;
            state.User_RegisterUserSuccess = action.payload;
        },

    },
});

// Reducer
export default slice.reducer;

// Actions
export const { startLoading, hasError, User_RegisterUserSuccess } = slice.actions;

// ----------------------------------------------------------------------



// export function User_RegisterUser(USEREMAIL, USERPASSWORD, USERROLE) {
//     return async (dispatch) => {
//         dispatch(slice.actions.startLoading());

//         try {
//             const requestUrl = `${SERVER_API}RegisterUser?USEREMAIL=${encodeURIComponent(USEREMAIL)}&USERPASSWORD=${encodeURIComponent(USERPASSWORD)}&USERROLE=${encodeURIComponent(USERROLE)}`;
            
//             const response = await fetch(requestUrl);
//             const json = await response.json();
//             const data = JSON.parse(json)[0];
//             const InsertedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
//             console.log(InsertedIDAfterJSON, 'InsertedIDAfterJSON In Backend');
//             if (data.ReturnVal === 1) {
//                 dispatch(slice.actions.User_RegisterUserSuccess(InsertedIDAfterJSON));
//             } else {
//                 dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
//             }
//         } catch (error) {
//             dispatch(slice.actions.hasError(error));
//         }
//     };
// }

export function User_RegisterUser(USERNAME, PHONENUMBER, EVENTVENUE, USEREMAIL, USERPASSWORD, USERROLE) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());

        try {
            const requestUrl = `${SERVER_API}RegisterUser?USERNAME=${encodeURIComponent(USERNAME)}&PHONENUMBER=${encodeURIComponent(PHONENUMBER)}&EVENTVENUE=${encodeURIComponent(EVENTVENUE)}&USEREMAIL=${encodeURIComponent(USEREMAIL)}&USERPASSWORD=${encodeURIComponent(USERPASSWORD)}&USERROLE=${encodeURIComponent(USERROLE)}`;
            
            const response = await fetch(requestUrl);
            const json = await response.json();
            const data = JSON.parse(json)[0];
            const InsertedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
            console.log(InsertedIDAfterJSON, 'InsertedIDAfterJSON In Backend');
            if (data.ReturnVal === 1) {
                dispatch(slice.actions.User_RegisterUserSuccess(InsertedIDAfterJSON));
            } else {
                dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}


